
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { WhiteLabelService } from '../_service/white-label.service';
import { DeviceService } from '../_service/tv-detect.service';

@Injectable({ providedIn: 'root' })
export class WhiteLabelRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private whitelabelService: WhiteLabelService,
    private deviceService: DeviceService
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // TV-only: skip the channel/entry mismatch redirect when this navigation
    // was triggered by Back (popstate). The redirect re-routes to the channel
    // root, changing the URL key the user came from — which breaks the focus
    // memory restore in TVFocusMemoryService.restoreFocusPosition(this.router.url)
    // on the destination page, causing focus to land on Banners' Watch Now
    // instead of the user's last-focused thumbnail (OpenProject #2675, #2776).
    // The mismatch check still runs for forward (imperative) navigation.
    // Gated on deviceService.isTV() so web behaviour is unchanged.
    const trigger = this.router.getCurrentNavigation()?.trigger;
    if (this.deviceService.isTV() && trigger === 'popstate') {
      return true;
    }

    if (this.whitelabelService.isInvalidWhiteLabel) {
      this.router.navigate(['/wl-invalid'], { replaceUrl: true });
      return false;
    }
    const storedChannel = localStorage.getItem('wl_channel');
    const storedEntry = localStorage.getItem('wl_entry');
    const targetURL = state.url;
    console.log('🔍 Guard triggered for target URL:', targetURL);
    console.log('📝 Route params:', route.params);
    console.log('📝 Route path:', route.routeConfig?.path);
    if (storedChannel && storedEntry) {
      const urlSegments = targetURL.split('/').filter(Boolean);
      const currentChannel = urlSegments.find(segment => segment.startsWith('@'));
      const channelIndex = urlSegments.findIndex(segment => segment.startsWith('@'));
      const currentEntry = channelIndex !== -1 ? urlSegments[channelIndex + 1] : null;
      
      const routeChannel = route.params['channel'];
      const routeEntry = route.params['entry'];
      
      const finalChannel = currentChannel || (routeChannel ? `@${routeChannel}` : null);
      const finalEntry = currentEntry || routeEntry;
      
      console.log('📊 Guard analysis:', {
        targetURL,
        storedChannel,
        storedEntry,
        currentChannel,
        currentEntry,
        routeChannel,
        routeEntry,
        finalChannel,
        finalEntry,
        urlSegments
      });
      
      const channelMismatch = finalChannel && finalChannel !== storedChannel;
      const entryMismatch = finalEntry && (finalEntry === 'f' || finalEntry === 'v') && finalEntry !== storedEntry;
      
      if (channelMismatch || entryMismatch) {
        console.log('🚫 BLOCKING NAVIGATION - Mismatch detected');
        console.log('Channel mismatch:', channelMismatch, 'Entry mismatch:', entryMismatch);
        console.log('Expected:', storedChannel, storedEntry, 'Got:', finalChannel, finalEntry);
        const route = this.whitelabelService.getPrefixedRoute('')
        this.router.navigate([route]);
        return false;
      }
    }
    
    console.log('✅ Navigation allowed');
    return true;
  }
}